import React from 'react';
import { useContext, useEffect } from "react";
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Language } from "../languages"
import { LanguageContext, RateCard, RateCardOverride } from "../Helpers/Context";
import useAxios from 'axios-hooks';

export default function RateCardList() {
    const { language, dictionary, complexity, rateCard, setRateCard, rateCardOverride, setRateCardOverride, officeId } = useContext(LanguageContext);

    const handleListItemClick = (
        item: RateCard,
    ) => {
        setRateCard(item);
    };

    const [{ data, loading }] = useAxios<RateCard[]>(
        `RateCard?taxEngineId=1&complexityId=${complexity?.complexityId}`,
        { manual: !complexity }
    );

    const [{ data: dataOverride, loading: loadingOverride }] = useAxios<RateCardOverride[]>(
        `RateCard/Override?officeId=${officeId}`
    );

    useEffect(() => {
        // Update override when officeId or selected rateCard changes
        if (dataOverride && !loadingOverride && rateCard) {
            let override = dataOverride?.find(x => x.rateId === rateCard.rateID && x.rowStatus === "A");
            setRateCardOverride(override);
        }
    }, [dataOverride, loadingOverride, rateCard, setRateCardOverride, officeId]);

    useEffect(() => {
        //Update override info when a Post happens (rateCardOverride object was changed)
        if (dataOverride && !loadingOverride && rateCardOverride && rateCardOverride.officeId === officeId) {

            let objIndex = dataOverride.findIndex((obj => obj.rateId === rateCardOverride?.rateId));

            if (objIndex >= 0) {
                if (dataOverride[objIndex].rate !== rateCardOverride.rate ||
                    dataOverride[objIndex].complexityId !== rateCardOverride.complexityId ||
                    dataOverride[objIndex].rowStatus !== rateCardOverride.rowStatus) {
                    // only update existing when there is a change
                    dataOverride[objIndex].rate = rateCardOverride.rate;
                    dataOverride[objIndex].complexityId = rateCardOverride.complexityId;
                    dataOverride[objIndex].rowStatus = rateCardOverride.rowStatus;
                }
            }
            else {
                dataOverride.push(rateCardOverride);
            }
        }
    }, [dataOverride, loadingOverride, rateCardOverride, officeId]);

    let rateCards = data;
    if (rateCards) {
        if (language === Language.English) {
            rateCards = rateCards.sort((a, b) => (a.descrip < b.descrip ? -1 : 1));
        }
        else {
            rateCards = rateCards.sort((a, b) => (a.descripFr < b.descripFr ? -1 : 1));
        }
    }

    return (
        <React.Fragment>
            <Typography variant="h6" color="primary">
                {language === Language.English ? complexity?.description : complexity?.descriptionFr}: {dictionary.rateCardListTitle}
            </Typography>
            {loading && (
                <CircularProgress />
            )}
            {rateCards && !loading && (
                <List style={{ maxHeight: 400, overflow: 'auto' }}>
                    {rateCards?.map((item) =>
                    (
                        <ListItem
                            key={item.rateID}
                            button
                            selected={rateCard?.rateID === item.rateID}
                            onClick={() => handleListItemClick(item)}
                        >
                            <ListItemText primary={language === Language.English ? item.descrip : item.descripFr} />
                        </ListItem>
                    ))}
                </List>
            )}
        </React.Fragment>
    );
}